import { render, staticRenderFns } from "./ProtocolDetail.vue?vue&type=template&id=0029ff02&"
import script from "./ProtocolDetail.vue?vue&type=script&lang=js&"
export * from "./ProtocolDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolDetail.vue?vue&type=style&index=0&id=0029ff02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports